import { render, staticRenderFns } from "./CreatePrivilegeForm.vue?vue&type=template&id=261d9d85&scoped=true&"
import script from "./CreatePrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./CreatePrivilegeForm.vue?vue&type=script&lang=js&"
import style0 from "./CreatePrivilegeForm.vue?vue&type=style&index=0&id=261d9d85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d9d85",
  null
  
)

export default component.exports